export class ParserError extends Error {
    /**
     * CDDL tokenizer or parser error
     */
    constructor(message = "A parsing error occurred") {
        super(message);
        this.name = "ParserError";
    }
}
//# sourceMappingURL=errors.js.map